import { memo } from 'react'
import { IconChevronLeft } from '@tabler/icons-react'
import { useSwipeBack } from '../lib/useSwipeBack'
import { safeSheetOpenHaptic } from '../lib/safeTelegram'

function CategoryScreen({ title, onBack, showBackButton = true, children }) {
  const swipeHandlers = useSwipeBack(onBack, Boolean(onBack))
  const hasBackButton = Boolean(onBack) && showBackButton

  const handleBack = () => {
    safeSheetOpenHaptic()
    onBack?.()
  }

  return (
    <div
      className="tma-flow-screen animate-fade-in"
      {...swipeHandlers}
      style={onBack ? { touchAction: 'pan-y', overscrollBehavior: 'none' } : undefined}
    >
      <div className={`mb-4 flex items-center ${hasBackButton ? 'gap-2' : 'justify-center'}`}>
        {hasBackButton ? (
          <button
            type="button"
            onClick={handleBack}
            className="tma-back-button premium-card flex h-10 w-10 shrink-0 items-center justify-center rounded-full active:scale-95"
            aria-label="Назад"
          >
            <IconChevronLeft size={20} stroke={2.2} className="text-[var(--color-text)]" />
          </button>
        ) : null}
        <h2 className="tma-screen-title text-center text-[24px] font-semibold leading-7 tracking-[-0.01em] text-[var(--color-text)]">{title}</h2>
      </div>
      {children}
    </div>
  )
}

export default memo(CategoryScreen)
